'use client';

import CloseIcon from '@mui/icons-material/Close';
import { Box, ButtonBase, IconButton, Modal, Typography } from '@mui/material';
import { useState } from 'react';

export function EditorialIntegrity() {
  const [showDiscloser, setShowDiscloser] = useState(false);

  const handleClick = () => {
    setShowDiscloser(true);
  };

  const closeModal = () => {
    setShowDiscloser(false);
  };

  return (
    <>
      <ButtonBase onClick={handleClick}>
        <Typography
          variant="notesHighlightSmall"
          sx={{
            fontFamily: 'var(--font-gotham), Gotham, sans-serif',
            '&:hover': { color: 'white' },
          }}
        >
          Editorial Integrity
        </Typography>
      </ButtonBase>
      <Modal
        open={showDiscloser}
        onClose={closeModal}
        keepMounted
        disableScrollLock
        disablePortal
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'center',
          color: 'black',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'white',
            paddingTop: '1.5rem',
            paddingBottom: { xs: '2.5rem', sm: '5rem' },
            width: '100%',
            borderRadius: '8px 8px 0 0',
            boxShadow: '0px -4px 4px 0px #00000026',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '1280px',
              paddingX: { xs: 3, sm: 6 },
              marginX: 'auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                marginBottom: '1.5rem',
              }}
            >
              <Typography variant="textLargeBold">
                NerdWallet is committed to editorial integrity
              </Typography>
              <IconButton onClick={closeModal} size="medium" sx={{ marginLeft: 3 }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography>
              Many or all of the products on this page are from partners who compensate us when you
              click to or take an action on their website,{' '}
              <strong>
                but this does not influence our evaluations or ratings. Our opinions are our own.
              </strong>
            </Typography>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
